import { FC } from 'react';

const GroupsLoader: FC = () => (
    <div className="px-4 flex flex-col gap-4">
        <span className="font-sf text-13 leading-[15.51px] text-sf-gray-500">Group membership</span>
        <div className="flex gap-2 flex-wrap animate-pulse">
            <div className="h-6 w-[92px] rounded-[4px] bg-sf-gray-100" />
            <div className="h-6 w-[95px] rounded-[4px] bg-sf-gray-100" />
            <div className="h-6 w-[109px] rounded-[4px] bg-sf-gray-100" />
            <div className="h-6 w-[98px] rounded-[4px] bg-sf-gray-100" />
        </div>
    </div>
);

export default GroupsLoader;
